import { getSortFields } from 'apps/auth/components/form-multi/utils';
import { FINISH_REGISTRATION, PROFILE_EDIT_FORM_NAME } from 'apps/auth/constants/formName';
import { apiFetchData } from 'apps/auth/helpers/api';

export const getFieldsToEdit = (profileData = [], step = 0) => {
    const fields = profileData[step];
    return fields ? getSortFields(fields) : [];
};

export const isFieldDataUnchanged = (allFields, currentFields) => {
    const allFieldsSorted = getSortFields(allFields);
    if (!allFieldsSorted.length || !currentFields.length) return false;

    const getFieldValues = (arr) => arr.map(({ name, value }) => ({ name, value }));

    const allFieldsValues = getFieldValues(allFieldsSorted);
    const currentFieldsValues = getFieldValues(currentFields);

    return currentFieldsValues.every(({ name, value }) =>
        allFieldsValues.some((field) => field.name === name && (field.value === value || (!field.value && !value))),
    );
};

export const fetchCountryRegistrationFields = (countryCode) => {
    return apiFetchData(`/auth/profile/registration/finish/get/new/fields/for/country/${countryCode.toLowerCase()}`).then((json) => ({
        fields: json.forms[FINISH_REGISTRATION]?.fields || null,
        messages: json.messages || {},
    }));
};

export const fetchCountryProfileFields = (countryCode) => {
    return apiFetchData(`/auth/profile/registration/get/new/fields/for/country/${countryCode.toLowerCase()}`).then((json) => ({
        fields: json.forms[PROFILE_EDIT_FORM_NAME]?.fields || null,
        messages: json.messages || {},
    }));
};
